<template>
  <div
    class="grooverBtn"
    :class="cmpClass"
    :style="anistate"
    tabindex="0"
    @keydown.enter="focus = true"
    @keyup.enter="handleEnterKeyPressed"
    @focus="hover = true"
    @blur="hover = false"
    @click="emitClick"
    @mouseenter="hover = true"
    @mouseleave=";(hover = false), (focus = false)"
    @mousedown="focus = true"
    @mouseup="focus = false"
  >
    <slot v-if="!text" />
    <div v-else class="btnText">
      {{ text }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue'

import animixin from '~/mixins/animations'

export default defineComponent({
  mixins: [animixin],
  props: {
    text: [String, Number],
    visual: {
      type: String,
      default: 'main',
      validator(value: string) {
        const available = [
          'small',
          'cutemain',
          'keromain',
          'hachimain',
          'main',
          'bigroundmain',
          'bigmain',
          'hollowmain',
          'bighollowmain',
          'hugemain',
          'param',
          'smallparam',
          'hollowparam',
          'bighollowparam',
          'hugeparam',
          'facebook',
          'grey',
        ]

        return available.includes(value)
      },
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      hover: false,
      cmpHover: false,
      focus: false,
      cmpFocus: false,
    }
  },
  computed: {
    cmpClass() {
      const ret = {} as Record<string, any>

      ret[this.visual] = true
      ret.disabled = this.disabled || this.loading
      ret.loading = this.loading
      ret.hover = this.cmpHover
      ret.focus = this.cmpFocus
      ret.enabled = this.enabled
      return ret
    },
  },
  watch: {
    hover() {
      this.chooseAnistate()
    },
    focus() {
      this.chooseAnistate()
    },
    cmpHover() {
      this.chooseAnistate()
    },
  },
  methods: {
    emitClick() {
      if (!this.disabled) this.$emit('click')
    },
    chooseAnistate() {
      if (this.cmpHover && this.hover) {
        this.aniSpeed = 0.15
        this.changeAniSate('standard')
        if (!this.focus && this.cmpFocus) this.changeAniSate('decelerate')
      }
      if (this.cmpHover && !this.hover) {
        this.aniSpeed = 0.1
        this.changeAniSate('decelerate')
      }
      nextTick(() => {
        this.updateCmps()
      })
    },
    handleEnterKeyPressed() {
      this.emitClick()
      this.focus = false
    },
    updateCmps() {
      this.cmpHover = this.hover
      this.cmpFocus = this.focus
    },
  },
})
</script>

<style scoped src="./actionButton.css"></style>
<style scoped src="./actionButton720.css"></style>
<style src="./actionButtonUnscoped.css"></style>
